/* eslint-disable no-undef */
const { useState, useEffect } = require("react");
import { Modal, Col, Button, Tooltip } from "reactstrap";

const Modals = ({ matchType, terms }) => {
  const [toggle, setToggle] = useState(false);
  const [formattedTerms, setFormattedTerms] = useState([]);
  const [tooltipOpenSimilarity, setTooltipOpenSimilarity] = useState(false);
  const toggleTooltipSimilarity = () =>
    setTooltipOpenSimilarity(!tooltipOpenSimilarity);

  useEffect(() => {
    if (terms) {
      try {
        const termsArray = JSON.parse(terms);
        setFormattedTerms(termsArray);
        console.log("Termos carregados:", termsArray);
      } catch (error) {
        console.error("Erro ao carregar os termos:", error);
        setFormattedTerms([]);
      }
    }
  }, [terms]);

  return (
    <Col lg="12" style={{ padding: 0 }}>
      <Button
        className="Button"
        size="sm"
        color="primary"
        onClick={() => setToggle(true)}
      >
        Visualizar
      </Button>
      <Modal
        className="modal-dialog modal-xl"
        style={{ marginTop: "100px" }}
        isOpen={toggle}
        toggle={() => setToggle((v) => !v)}
      >
        <div className="modal-header">
          <div className="modal-title">
            <h3>
              Termos enquadrados em <u>{matchType}</u>
            </h3>
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setToggle((v) => !v)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {formattedTerms?.length ? (
            <table className="table table-striped">
              <thead>
                <tr className="checked-table">
                  <th>Termo</th>
                  <th>Precisão</th>
                  {matchType === "Similaridade" && (
                    <th>
                      Similaridade{" "}
                      <i className="fas fa-info-circle" id="similarity-label" />
                      <Tooltip
                        placement="right"
                        isOpen={tooltipOpenSimilarity}
                        target="similarity-label"
                        toggle={toggleTooltipSimilarity}
                      >
                        <div style={{ margin: "0", padding: "0" }}>
                          Se a semelhança for maior que{" "}
                          {process.env.REACT_APP_SIMILARITY_THRESHOLD ?? "70"}%,
                          consideramos uma correspondência válida.
                        </div>
                      </Tooltip>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {formattedTerms.map((term, index) => (
                  <tr key={index} className="checked-table">
                    <td>{term.term}</td>
                    <td>
                      {Math.round(
                        (term.transcription_assertiveness * 100).toFixed(2),
                      )}
                      %
                    </td>
                    {term.similarity && (
                      <td>
                        {term.similarity
                          ? `${Math.round(term.similarity)}%`
                          : "N/A"}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            "Nenhum termo encontrado"
          )}
        </div>
      </Modal>
    </Col>
  );
};

export default Modals;
